import React from "react";
import { MessageImageLink, MessageImageStyle } from "./style";
import {
  G4Cliente,
  G4Wait,
  G4Atendente,
} from "../../../pages/conversation/components/styled";
import { Hours } from "../../styled";
import { WebchatContext } from "../../../context/WebchatContext";
import { useContext } from "react";

const Message = ({ time, source, user, config, description }) => {
  const { modeWebchatFull } = useContext(WebchatContext);
  const hasDescription = Boolean(description && description.length > 0);
  const hideBalloon = !hasDescription;
  const content = (
    <>
      <MessageImageLink href={source} target="_blank" rel="noopener noreferrer">
        <MessageImageStyle
          modeWebchatFull={modeWebchatFull}
          src={source}
          alt={description || "Imagem"}
        />
      </MessageImageLink>
      {hasDescription && (
        <p style={{ fontSize: "15px", margin: "8px 4px 0" }}>{description}</p>
      )}
      <Hours>
        {new Date(time).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })}
      </Hours>
    </>
  );

  return (
    <>
      {user === "cliente" && (
        <G4Cliente
          modeWebchatFull={modeWebchatFull}
          color={config.color}
          isImage
          hideBalloon={hideBalloon}
          backgroundColorConfig={
            hasDescription ? config?.backgroundBallonClient : undefined
          }
          colorText={hasDescription ? config?.textColorBallonClient : undefined}
        >
          {content}
        </G4Cliente>
      )}
      {user === "atendente" && (
        <G4Atendente
          modeWebchatFull={modeWebchatFull}
          isImage
          hideBalloon={hideBalloon}
          backgroundColorConfig={
            hasDescription ? config?.backgroundBallonAttendant : undefined
          }
          colorText={hasDescription ? config?.textColorBallonAttendant : undefined}
        >
          {content}
        </G4Atendente>
      )}
      {user === "wait" && <G4Wait color={config.color}>{content}</G4Wait>}
    </>
  );
};

export default Message;
